/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthDeclarationValidAliases {
  ACCESSIBILITY_0 = 'accessibility-0',
  APPLICATION_BAR_0 = 'application-bar-0',
  BUTTON_SUBMIT_CODE = 'button-submit-code',
  DATE_FIELD_BIRTH = 'date-field-birth',
  FIELD_CODE = 'field-code',
  FIELD_DT_BIRTH = 'field-dt-birth',
  FORM_0 = 'form-0',
  FRAGMENT_FOOTER = 'fragment-footer',
  INPUT_CODE = 'input-code',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_3 = 'layout-3',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_8 = 'panel-8',
  RECAPTCHA = 'recaptcha',
  ROOT_COMPONENT = 'root-component',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
}
export { HealthDeclarationValidAliases };
